import { render, staticRenderFns } from "./SimpleContract.vue?vue&type=template&id=700a995f&scoped=true&"
import script from "./SimpleContract.vue?vue&type=script&lang=js&"
export * from "./SimpleContract.vue?vue&type=script&lang=js&"
import style0 from "./SimpleContract.vue?vue&type=style&index=0&id=700a995f&lang=scss&scoped=true&"
import style1 from "./SimpleContract.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "700a995f",
  null
  
)

export default component.exports